import { Description } from "./description";
import { Indicator } from "./indicator";
import { OraclePill } from "./oracle-pill";

export const Oracle = {
  OraclePill,
  Indicator,
  Description,
};
